
export enum AddTeamMemberMethod {
  NewUser, ExistingUser
}

export enum AddTeamMemberView {
  AddUser, UserAddedSuccessful, AtUserLimit, UserMovedSuccessful
}
